import { Tab, Tabs, Grid, Paper } from '@mui/material';
import { useEffect, useMemo, useState } from 'react';
import { OfficesTab } from './office-tab/offices-tab.component';
import { useParams } from 'react-router-dom';
import { TabPanel } from '../../../components/tab-panel';
import { ProjectsTab } from './project-tab/projects-tab';
import { LotsTab } from './lots-tab/lots-tab';
import { CustomerDetailsTab } from './customer-contacts-tab/customer-contacts-tab';
import { ServicesTab } from './services-tab/services-tab';
import { FilesTab } from './file-tab/files.tab';
import { ContractsTab } from './contract-tab/contracts.tab';
import { UserPermissionName } from '../../../models/user-permission-name';
import { useAuthorize } from '../../../hooks/use-authorize';

interface DetailsTabs {
  contracts: any;
  permissionForTab: any;
}

export const DetailsTabs = ({ contracts, permissionForTab }: DetailsTabs) => {
  const { id } = useParams();
  const [value, setValue] = useState('offices');

  const handleTabsChange = (event: any, value: any) => {
    setValue(value);
  };
  const availableTabs = useMemo(
    () =>
      [
        permissionForTab?.officeTab && 'offices',
        permissionForTab?.projectTab && 'projects',
        permissionForTab?.unitTab && 'lots',
        permissionForTab?.contactTab && 'customer-contacts',
        permissionForTab?.serviceTab && 'services',
        permissionForTab?.fileTab && 'files',
        permissionForTab?.contractTab && 'contracts',
      ].filter(Boolean),
    [permissionForTab]
  );

  useEffect(() => {
    if (!availableTabs.includes(value)) {
      setValue(availableTabs[0] as string);
    }
  }, [availableTabs]);

  if (!id) {
    return <div>Invalid Customer</div>;
  }

  const isViewContractPermission = useAuthorize([UserPermissionName?.VIEW_CONTRACT_CUSTOMER]);

  return (
    <Paper elevation={0} sx={{ mt: 2 }}>
      <Grid item>
        <Tabs value={value} onChange={handleTabsChange}>
          <Tab value="offices" label="Offices" hidden={!permissionForTab?.officeTab} />
          <Tab value="projects" label="Projects" hidden={!permissionForTab?.projectTab} />
          <Tab value="lots" label="Lots/Units" hidden={!permissionForTab?.unitTab} />
          <Tab value="customer-contacts" label="Customer Contacts" hidden={!permissionForTab?.contactTab} />
          <Tab value="services" label="Services" hidden={!permissionForTab?.serviceTab} />
          <Tab value="files" label="Files" hidden={!permissionForTab?.fileTab} />
          <Tab value="contracts" label="Contracts" hidden={!permissionForTab?.contractTab} />
        </Tabs>

        {/* Conditionally render TabPanels based on selected tab and permissions */}
        {value === 'offices' && permissionForTab?.officeTab && (
          <TabPanel selectedValue={value} value="offices">
            <OfficesTab customerID={Number(id)} />
          </TabPanel>
        )}
        {value === 'projects' && permissionForTab?.projectTab && (
          <TabPanel selectedValue={value} value="projects">
            <ProjectsTab customerID={Number(id)} />
          </TabPanel>
        )}
        {value === 'lots' && permissionForTab?.unitTab && (
          <TabPanel selectedValue={value} value="lots">
            <LotsTab customerID={Number(id)} />
          </TabPanel>
        )}
        {value === 'customer-contacts' && permissionForTab?.contactTab && (
          <TabPanel selectedValue={value} value="customer-contacts">
            <CustomerDetailsTab customerID={Number(id)} />
          </TabPanel>
        )}
        {value === 'services' && permissionForTab?.serviceTab && (
          <TabPanel selectedValue={value} value="services">
            <ServicesTab customerID={Number(id)} />
          </TabPanel>
        )}
        {value === 'files' && permissionForTab?.fileTab && (
          <TabPanel selectedValue={value} value="files">
            <FilesTab customerID={Number(id)} />
          </TabPanel>
        )}
        {value === 'contracts' && permissionForTab?.contractTab && (
          <TabPanel selectedValue={value} value="contracts">
            <ContractsTab contracts={contracts} />
          </TabPanel>
        )}
      </Grid>
    </Paper>
  );
};
